import { Button, Typography } from "@mui/material";
import React from "react";

const HoverButton = ({
  btnText,
  color,
  background = "transparent",
  fillBgColor = "#F0E2D6",
  width = "132px",
  height = "50px",
  startIcon,
  endIcon,
  sx,
  fontWeight,
  onClick,
}) => {
  const btnStyle = {
    color: color ? color : "black",
    width: width,
    height: height,
    borderRadius: 0,

    display: "flex",
    justContent: "center",
    alignItems: "center",
    border: "1px solid black",
    zIndex: 1,
    cursor: "pointer",
    background: background,
    position: "relative",
    overflow: "hidden",
    transition: "ease 0.1s",
    "&::before": {
      content: '""',
      position: "absolute",
      height: "100%",
      width: "0%",
      top: 0,
      left: "-40px",
      backgroundColor: fillBgColor,
      zIndex: -1,
      transition: "all 1s",
    },
    "&:hover": {
      color: "black",
    },
    "&:hover::before": {
      width: "160%",
    },
  };
  const typoStyle = {
    fontSize: "16px",
    fontWeight: fontWeight ? fontWeight : "300",
    fontFamily: "Sora",
    lineHeight: "36px",
    letterSpacing: "0.01em",
    textTransform: "uppercase",
  };
  return (
    <Button
      onClick={onClick}
      sx={{ ...btnStyle, ...sx }}
      startIcon={startIcon}
      endIcon={endIcon}
      disableElevation
      disableRipple
    >
      <Typography sx={typoStyle}>{btnText}</Typography>
    </Button>
  );
};

export default HoverButton;
